// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"d09cd917","784":"31f0296b","846":"ffa31e8d","857":"63308c8b","944":"9bf003e9"}[chunkId] + ".chunk.css";
};